import * as universes from '@wecasa/common/src/ducks/common/universes';

import * as basket from '@wecasa/customer/src/ducks/basket';
import * as proAccounts from '@wecasa/customer/src/ducks/pro-accounts';

export default {
  universes,
  proAccounts,
  basket,
};
